import { useEffect, useState } from "react";
import { NewDownloadIcon } from "../../../../assets/images";
import { GetGenerateSasTokenPayloadType } from "../../../../commonTypes/stcoToolsType";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { formateDateWithTime } from "../../../../utils/commonFunctions";
import { CircularAvatar } from "../../../commons";

type AppProps = {
  data: any[] | [];
  tableHeader: TableHeadersType[];
  sasTokenForDownloadFile: string;
  token: string | null;
  dispatchResetSasTokenForDownloadFile: () => void;
  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => void;
};
const HRMSBulkUploadTableData = ({
  data,
  tableHeader,
  sasTokenForDownloadFile,
  dispatchResetSasTokenForDownloadFile,
  dispatchGetTokenGenerateForDownloadAction,
  token,
}: AppProps) => {
  const [fileName, setFileName] = useState("");

  const downloadBlobFile = async (file: any) => {
    setFileName(file?.file_name);
    let finalData = {
      fileUrl: file?.file_url,
      token,
      containerType: 1,
    };
    dispatchGetTokenGenerateForDownloadAction(finalData);
  };

  useEffect(() => {
    if (sasTokenForDownloadFile) {
      const link = document.createElement("a");
      link.href = sasTokenForDownloadFile;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      dispatchResetSasTokenForDownloadFile();
    }
  }, [sasTokenForDownloadFile]);

  const readyTypeStyle = () => {
    return {
      padding: "4px 12px",
      color: "#82b01f",
      background: "#e7f0d4",
      borderRadius: "16px",
      width: "80px",
    };
  };

  const processingTypeStyle = () => {
    return {
      padding: "4px 12px",
      color: "#f3a119",
      background: "#faedd8",
      borderRadius: "16px",
      width: "106px",
    };
  };
  return (
    <>
      {data &&
        data?.length > 0 &&
        data?.map((itemData: any) => {
          return (
            <tr key={itemData?._id}>
              {tableHeader?.map((item: TableHeadersType) => {
                if (item?.value == "file") {
                  return (
                    <td style={{ minWidth: "220px" }}>
                      {itemData?.file?.file_name}
                    </td>
                  );
                } else if (item?.value == "stage") {
                  return (
                    <td>
                      <span
                        style={
                          itemData?.processing_status === true
                            ? processingTypeStyle()
                            : readyTypeStyle()
                        }
                      >
                        {itemData?.processing_status === true
                          ? "Processing"
                          : "Ready"}
                      </span>
                    </td>
                  );
                } else if (item?.value === "created") {
                  return (
                    <td className="text-start" style={{ minWidth: "180px" }}>
                      <div
                        className="ml-2"
                        style={{
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                          gap: "7px",
                        }}
                      >
                        <CircularAvatar
                          name={`${itemData?.created_by?.first_name} ${itemData?.created_by?.last_name}`}
                          image={
                            itemData?.created_by?.profile_pic &&
                            itemData?.created_by?.profile_pic?.file_url
                          }
                        />
                        <div>
                          {`${itemData?.created_by?.first_name} ${itemData?.created_by?.last_name} `}
                        </div>
                      </div>
                    </td>
                  );
                } else if (item?.value == "created_at") {
                  return <td>{formateDateWithTime(itemData?.created_at)}</td>;
                } else if (item?.value == "action") {
                  return (
                    <td>
                      <span 
                      >
                        <a
                        style={{cursor:'pointer'}}
                          href="#"
                          target="_blank"
                          onClick={(e) => {
                            e.preventDefault();
                            downloadBlobFile(itemData?.file);
                          }}
                          className="uploaded_file_name"
                        >
                          <img src={NewDownloadIcon} />
                        </a>
                      </span>
                    </td>
                  );
                }
              })}
            </tr>
          );
        })}
    </>
  );
};

export default HRMSBulkUploadTableData;
